export const WIDGET_ACTIONS = {
    INIT: 'WIDGET/INIT',
    OPEN: 'WIDGET/OPEN',
    OPEN_POPUP: 'WIDGET/OPEN_POPUP',
    CLOSE: 'WIDGET/CLOSE',
    CLOSED: 'WIDGET/CLOSED',
    MINIMIZED: 'WIDGET/MINIMIZED',
    MAXIMIZED: 'WIDGET/MAXIMIZED',
    MAXIMIZE: 'WIDGET/MAXIMIZE',
    RESIZE: 'WIDGET/RESIZE',
    SWITCH: 'WIDGET/SWITCH',
    DEBUG: 'WIDGET/DEBUG',
    CALL: 'WIDGET/CALL',
    DOCUMENT_CLICK: 'WIDGET/DOCUMENT_CLICK',
    INVITE_RESULT_SEND: 'WIDGET/INVITE_RESULT_SEND',
    GETSTATE: 'WIDGET/GETSTATE',
    STATE: 'WIDGET/STATE',
    CLOSEPREVIEW: 'WIDGET/CLOSEPREVIEW',
    CHAT_MESSAGERECEIVED: 'CHAT/MESSAGERECEIVED',
    CHAT_DOWNLOAD: 'CHAT/DOWNLOAD',
    BROADCAST_ORDER_ID_TO_CHAT: 'WIDGET/BROADCAST_ORDER_ID_TO_CHAT',
    SEND_ORDER_ID_TO_CHAT: 'WIDGET/SEND_ORDER_ID_TO_CHAT',
    SEND_USER_MO_LOGGED_IN_TO_CHAT: 'SEND_USER_MO_LOGGED_IN_TO_CHAT'
};

export const COOKIES = {
    START_CHAT: 'COOKIE/START_CHAT',
    STOP_CHAT: 'COOKIE/STOP_CHAT',
    START_QUESTIONNAIRE: 'COOKIE/START_QUESTIONNAIRE',
    CHECK_USABILA: 'COOKIE/CHECK_USABILA',
    SET_DISABLING_PROACTIVE_COOOKIE: 'COOKIE/SET_DISABLING_PROACTIVE_COOOKIE'
};
